import { useSelector } from "react-redux";
import _ from "lodash";

import { getVisibleProfiles } from "../../store/profiles/profiles.selectors";
import { useIntlTranslate } from "../../hooks";
import { ProfileType } from "../../store/profiles/profiles.types";
import { useAppParams } from "../../router";

export const useSelectedProfileName = (fallbackName = "") => {
  const { profileId } = useAppParams();
  const profiles = useSelector(getVisibleProfiles, _.isEqual);
  const translate = useIntlTranslate();

  const existingProfile = _.find(profiles, { id: profileId });

  if (existingProfile) {
    const { type, name } = existingProfile;

    return type === ProfileType.Custom ? name : translate(type);
  } else {
    return fallbackName;
  }
};
